import React from 'react';

interface ResultSummaryProps {
  total: number;
  selectedCount?: number;
}

/**
 * 搜索结果统计提示组件
 * 显示总结果数和已选择供应商数量
 */
export const ResultSummary: React.FC<ResultSummaryProps> = ({ total, selectedCount }) => {
  const parts: React.ReactNode[] = [];

  if (total > 0) {
    parts.push(
      <span key="total">
        Total <span className="font-medium text-[#2563EB]">{total.toLocaleString()}</span> results
      </span>
    );
  }

  if (selectedCount && selectedCount > 0) {
    parts.push(
      <span key="selected">
        <span className="font-medium text-[#2563EB]">{selectedCount}</span> suppliers selected
      </span>
    );
  }

  if (parts.length === 0) return null;

  return (
    <div className="flex items-center gap-2 w-[325px]">
      <p
        className="text-[#262626]"
        style={{
          fontFamily: 'Geist, sans-serif',
          fontSize: 12,
          fontWeight: 400,
          lineHeight: '1.5em',
          letterSpacing: '0.015em',
        }}
      >
        {parts.reduce<React.ReactNode[]>((acc, part, index) => {
          if (index > 0) acc.push(<span key={`sep-${index}`}>, </span>);
          acc.push(part);
          return acc;
        }, [])}
      </p>
    </div>
  );
};
